/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Week_Session_Day_Names_FridayInputs */

const fr_week_session_day_names_friday = /** @type {(inputs: Week_Session_Day_Names_FridayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ven`)
};

/**

* @param {Week_Session_Day_Names_FridayInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const week_session_day_names_friday = /** @type {((inputs?: Week_Session_Day_Names_FridayInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Week_Session_Day_Names_FridayInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_week_session_day_names_friday(inputs)
});